// extracted by mini-css-extract-plugin
export default {"filesContainer":"Attachments_filesContainer__JcOWI"};